import Link from "next/link";
import React from "react";
import { Comments } from "../../assets";

export default function Posts({
  imageUrl,
  tags,
  title,
  author,
  date,
  description,
  slugUrl,
}) {
  return (
    <Link href={`/blog/${slugUrl}`} className="article">
      <img alt="article_picture" src={imageUrl} />
      <div className="article_info_container">
        <ul>
          {tags.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>
        <h2 className="article_title">{title}</h2>
        <div className="article_info">
          <span>{author}</span>
          <span>{date}</span>
        </div>
        <p>{description}</p>
      </div>
    </Link>
  );
}
